<template>
  <v-container fluid>
    <v-row wrap>
      <v-col sm="8"  offset-sm="2">
        <v-alert type="warning" :value="true">{{ $t('notAuthorizedToAccessResource') }}</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>
